import React, { useEffect, useState } from 'react'
import robo from '../images/robo.png';
import medicbg from '../images/bgmedic.jpg';
import TopNav, { BottomNav } from '../components/layoucomp/NavComponents';

export default function ErrorPage() {

    return (
        <>
            <div>
                <TopNav />
                <div className='landingBg  row align-items-center justify-content-center p-5'>
                    <div className='p-5'>

                    </div>
                    <div className='col-6 text-center'>
                        <h2 className='display-1 landText'>
                            404 !
                        </h2>
                        <p className='landText fs-1'>Page Not Found! </p>
                    </div>
                    <div className='col-6 animated-image-container text-center'>
                        <img className='animated-image img-fluid' src={robo} alt="robotDoc" />
                    </div>
                </div>
                <BottomNav />
            </div>
        </>
    )
}
